// extracted by mini-css-extract-plugin
export default {"container":"gO-z","topReviewHeading":"hO-z","criticalReview":"iO-z","favorableReview":"jO-z","vsSeparator":"kO-z"};